module.exports = __webpack_public_path__ + "static/media/mushroommovie_confetti.e0ad8b0c.gif";